<template>
	
	<HeaderBlock bgcolor="#00000000" border="0" />
	<CustomerLoadWait :customer="benefits" :cardBlocks="true" />

	<div v-if="benefits" class="simplePage" style="margin-top: -40px;">
		<img src="../assets/benefits.png" />
		<h1 v-if="benefits.monthlyBenefitsAmount > 0">You may be entitled to</h1>
		<h1 v-else>It doesn't appear you're eligible, but you may still want to complete a full application to be certain</h1>
		<span v-if="benefits.monthlyBenefitsAmount > 0" class="amount">{{ formatter.format(benefits.monthlyBenefitsAmount) }} per month.</span>
		<p>Use the InBest free benefits calculator to find out your exact benefit entitlement.  It should take less than 5 minutes to complete! </p>
		<div class="anchor-bottom">
			<MGButton text="Start" arrow @click="openInBest" />
		</div>
	</div>
</template>

<script>
import Services from '../mixins/Services';
import HeaderBlock from './elements/HeaderBlock.vue';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import MGButton from './elements/MGButton.vue';

export default {
	mixins: [Services],
	components: {HeaderBlock, CustomerLoadWait, MGButton},
data() {
	return {
		benefits: null
	}
},
methods: {
	onLoad: async function() {
		this._getCustomer(() => {
			this._getQuestionnaireByKey('InBest', (q) => {
			console.log(q, 'Questionnaire');
			this._getQuestionnaireAnswers(q.id, (answers) => {
				console.log(answers, 'all customer Answers');
				
				// Build benefitsRequest object from questionnaire answers
				const benefitsRequest = this.buildBenefitsRequest(answers, q, this.customer);
				console.log(benefitsRequest, 'Benefits Request');
				
				this._getBenefits((result) => {
					this.benefits = result;
					console.log(result, 'Benefits');
				}, benefitsRequest);
			});
		});
		});
	},
	
	buildBenefitsRequest: function(answers, questionnaire, customer) {
		const benefitsRequest = {
			relationshipStatus: '',
			dob: customer.person.dob.split('T')[0],
			childrenNum: 0,
			housingType: 0,
			postcode: '',
			monthlyIncomeAmount: 0,
			monthlyBenefitsAmount: 0
		};
		
		// Filter answers to only include the latest ones
		const latestAnswers = answers.filter(a => a.isLatest);
		
		// Map question keys to benefitsRequest properties
		latestAnswers.forEach(answer => {
			const question = questionnaire.questionnaireQuestions.find(q => q.question.key === answer.question.key);
			if (question) {
				const questionKey = question.question.key;
				// Remove suffix starting with underscore
				const cleanQuestionKey = questionKey.split('_')[0];
				switch (cleanQuestionKey) {
					case 'LiveWithPartner':
						if (answer.answer) {
							benefitsRequest.relationshipStatus = answer.answer.value;
						}
						break;
					case 'CHILDREN':
						if (answer.freeAnswer) {
							benefitsRequest.childrenNum = answer.freeAnswer;
						}
						break;
					case 'HOUSINGS':
						if (answer.freeAnswer) {
							benefitsRequest.housingType = answer.freeAnswer;
						}
						break;
					case 'Postcode':
						if (answer.freeAnswer) {
							benefitsRequest.postcode = answer.freeAnswer;
						}
						break;
					case 'HOUSEHOL':
						if (answer.freeAnswer) {
							benefitsRequest.monthlyIncomeAmount = parseFloat(answer.freeAnswer) || 0;
						}
						break;
				}
			}
		});
		
		return benefitsRequest;
	},
	
	openInBest: function() {
		if (this.benefits && this.benefits.benefitsCalculatorLink) {
			window.open(this.benefits.benefitsCalculatorLink, '_blank');
		}
	}
},
mounted: function () {
	this.onLoad();
},
}
</script>

<style scoped>

.simplePage {
text-align: center;
.v-col{
	padding: 0px;
}
.well {
	margin-top: 45px;
	padding: 25px;
	background-color: #f5f3f5;
	border-radius: 24px;
	h1{
		font-size: 16px;
	}
}
img {
	width: 96px;
	margin-bottom: 15px;
	margin-top: 15px;
}
h1 {
	font-size: 24px;
	margin-top: 8px;
	margin-bottom: 15px;
	text-align: center;
}
p {
	margin-top: 15px;
	margin-bottom: 15px;
	font-size: 14px;
	text-align: center;
}
.amount {
	font-size: 32px;
	font-weight: bold;
	display: block;
	margin: 15px 0;
	text-align: center;
}
.info {
	text-align: left;
	padding: 15px;
	background-color: var(--background-color-alt);
	border-radius: 6px;
	h1{
		font-weight: bold;
		font-size: 12px;
	}
	p {
		font-size: 12px;
		margin-top: 15px;
		margin-bottom: 15px;
	}
}
.partnership{
	margin-top: 30px;
	text-align: center;
	img {
		margin: 0px;
		margin-left: 5px;
		margin-bottom: -5px;
		width: 64px;
	}
}

}

@media(max-height: 800px) {
.anchor-bottom {
margin-top: 20px;
position: unset;
padding-bottom: 30px;
}
}

</style>
